import Logger from "../../../../core/internal/logger"
import { HackleInAppMessage } from "../../../../public/model"
import { InAppMessageConverter } from "../../InAppMessageConverter"
import { InAppMessagePresentationContext } from "../../present/presentation/InAppMessagePresentationContext"
import { InAppMessageViewEvent } from "../event/InAppMessageViewEvent"
import { InAppMessageViewEventHandleType } from "../event/InAppMessageViewEventHandleType"
import { InAppMessageUi } from "../InAppMessageUi"
import { InAppMessageView } from "./InAppMessageView"
import { InAppMessageViewStatus } from "./InAppMessageViewStatus"

export abstract class InAppMessageBaseView implements InAppMessageView {
  protected hackleInAppMessage: HackleInAppMessage

  constructor(
    public readonly context: InAppMessagePresentationContext,
    public readonly ui: InAppMessageUi,
    public readonly status: InAppMessageViewStatus
  ) {
    this.hackleInAppMessage = InAppMessageConverter.toPublic(context.inAppMessage)
  }

  abstract open(): Promise<void>
  abstract close(): void
  abstract destroy(): void

  handle(viewEvent: InAppMessageViewEvent, types: InAppMessageViewEventHandleType[] = ["TRACK", "ACTION"]): void {
    this.ui.viewEventHandleProcessor.process(this, viewEvent, types)
  }

  protected canOpen(): boolean {
    return this.status.canOpen()
  }

  protected handleOpenStarted(): void {
    this.status.current = "OPENING"
    this.ui.inAppMessageListener?.beforeInAppMessageOpen?.(this.hackleInAppMessage)
  }

  protected handleOpenCompleted(): void {
    this.handle(InAppMessageViewEvent.impression(this.ui.clock.currentMillis()))
    this.status.current = "OPENED"
    this.ui.inAppMessageListener?.afterInAppMessageOpen?.(this.hackleInAppMessage)
  }

  protected handleOpenFailed(error: unknown): void {
    Logger.log.error(`Failed to open inAppMessageView: ${error}`)
    this.destroy()
  }

  protected canClose(): boolean {
    return this.status.canClose()
  }

  protected handleCloseStarted(): void {
    this.ui.inAppMessageListener?.beforeInAppMessageClose?.(this.hackleInAppMessage)
    this.status.current = "CLOSING"
  }

  protected handleCloseCompleted(): void {
    this.handle(InAppMessageViewEvent.close(this.ui.clock.currentMillis()))
    this.destroy()
    this.ui.inAppMessageListener?.afterInAppMessageClose?.(this.hackleInAppMessage)
  }

  protected handleCloseFailed(error: unknown): void {
    Logger.log.error(`Failed to close inAppMessageView: ${error}`)
    this.destroy()
    this.ui.inAppMessageListener?.afterInAppMessageClose?.(this.hackleInAppMessage)
  }
}
